export class ServerHandler {
  static successAnswer(status: number | null): boolean {
      return !!(status && status >= 200 && status < 300);
  }
}
